<template>
	<v-dialog v-model="open" scrollable max-width="480px">
	    <v-card v-if="content" style="height: 100%;">
        	<v-form ref="form" v-model="valid" lazy-validation>
		        <v-card-text>
                    <v-flex xs12>
						<selected-content-card 
							class="selected-content-card"
							:content="content" 
							:allow-remove="false"
							:item="content">
						</selected-content-card>
                    </v-flex>
                </v-card-text>
                <v-card-text>
                	<v-flex xs12 pb-3>
                		<h3>Select expires date/time</h3>
                	</v-flex>
                    <v-flex xs12 pb-3>
						<v-date-picker ref="expiryDate" class="mr-3" :value="expiryDate" :no-title="true" @input="expiryDateChanged"></v-date-picker>
                    </v-flex>
                    <v-flex xs12>
                    	<v-text-field class="expiry-time" type="time" v-model="expiryTime" label="Time"></v-text-field>
                    </v-flex>
	            </v-card-text>
            </v-form>
	        </v-card-text>
			<v-divider></v-divider>
	        <v-card-actions>
	            <v-spacer></v-spacer>
	            <v-btn color="blue darken-1" flat @click="handleClose">Cancel</v-btn>
	            <v-btn color="blue darken-1" flat :loading="saving" @click="handleSave">Save</v-btn>
	        </v-card-actions>
	    </v-card>
	</v-dialog>
</template>

<script>
	import * as config from '@/config'
    import * as types from '@/stores/mutation-types'

	import SelectedContentCard from '@/components/SelectedContentCard.vue'

	export default {
		components: {
			SelectedContentCard
		},
		props: {
			value: {
				type: Boolean
			},
			formTitle: {
				type: String,
				default: 'Edit Headline'
			},
			content: {
				type: [Object, Array],
				default: null
			}
		},
		data () {
			return {
				open: false,
				saving: false,
				valid: true,
				expiryDate: null,
				expiryTime: null
			}
		},
		methods: {
			saveHeadlineContent () {
				if (this.content.id) {
					return axios.put(`${config.BASE_URL}/headline/content/${this.content.id}`, this.content)
				} else {
					return axios.post(`${config.BASE_URL}/headline/content`, this.content)
				}
			},
			handleSave () {
				this.content.expiresAt = `${this.expiryDate} ${this.expiryTime}:00`

				this.saveHeadlineContent()
					.then(response => {
						if (response.data.code == 0) {
							this.$emit('update', response.data.data)
							this.handleClose()
						} else {
							this.$store.commit(types.SET_ERROR_MSG, response.data.message)
						}
					})
			},
			handleClose () {
				this.open = false
				this.$emit('close')
				this.$emit('input', false)
			},
			expiryDateChanged (value) {
				this.expiryDate = value
			}
		},
		mounted () {
			this.open = this.value
		},
		watch: {
			value (newValue) {
				this.open = newValue
			},
			content: {
				handler (newValue) {
					if (newValue) {
						this.expiryDate = `${new Date(this.content.expiresAt).toISOString().split('T')[0]}`
						this.expiryTime = `${new Date(this.content.expiresAt).getHours()}:${new Date(this.content.expiresAt).getMinutes()}`
					}
				},
				deep: true
			}
		}
	}
</script>

<style lang="scss">
	.expiry-time {
		width: 75px;
	}
</style>